<template>
  <div class="container-fluid">
    <div class="form-row">
      <div class="form-group col-12">
        <button
          type="button"
          class="btn btn-default btn-sm"
          @click="addNewProductBtn"
        >
          Add New Product
        </button>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <product
          v-for="(product, index) in products"
          :key="product.id"
          v-model="products[index]"
          :index="product.id"
          @remove-product="removeProduct"
          @save-product="saveProduct"
        />
      </div>
    </div>

    <v-dialog
      v-model="isAddProductModalOpen"
      max-width="1350px"
    >
      <v-card>
        <template #title>
          New Product
        </template>
        <v-divider />
        <div class="px-3 pb-4">
          <product
            v-model="newProduct"
            @add-product="addProduct"
          />
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="isSnackbarOpen"
      :timeout="3000"
      location="top right"
    >
      <v-alert
        color="#dfe8e8"
        :title="title"
        :text="message"
      />
    </v-snackbar>
  </div>
</template>

<script>
import { lookup } from '../lookup/lookup';

import Product from './product.vue';

export default {
  components: {
    Product,
  },
  data() {
    return {
      newProduct: null,
      products: [],
      isAddProductModalOpen: false,
      isSnackbarOpen: false,
      message: '',
      title: '',
    };
  },

  async mounted() {
    this.products = await lookup.computed.products();
  },

  methods: {
    addNewProductBtn() {
      this.newProduct = {
        type_id: 3600,
      };
      this.isAddProductModalOpen = true;
    },
    saveProduct(product) {
      this.openSnackbar('Saved', product.name);
    },
    addProduct(product) {
      this.products.push(product);
      this.isAddProductModalOpen = false;

      this.openSnackbar('Added', product.name);
    },
    removeProduct(product) {
      this.products.splice(this.products.findIndex(item => item.id === product.id), 1);

      this.openSnackbar('Deleted', product.name);
    },

    openSnackbar(title, message) {
      this.isSnackbarOpen = true;
      this.title = title;
      this.message = message;
    },
  },
};
</script>
